import resourceNames from "./resourceNames";

export const exclusiveMasterResources = [
  resourceNames.MASTER_TENANTS,
  resourceNames.MASTER_TENANTS_VIEW,
];
